export const merchProducts = [
  {
    id: "identity-tee",
    status: "published",
    mockupUrl: null,
    alternateMockupUrls: [],
    collectionId: "identity",
    galleryKey: "identity-tee",
    name: "Identity Tee",
    collection: "Identity",
    collectionNumber: "Collection 001",
    category: "T-Shirt",
    descriptor: "Oversized heavyweight tee",
    shortDescription: "Premium streetwear centered around vehicle identity.",
    description: "A heavyweight oversized tee created for Collection 001. The front carries the official MyBuildID mark while the back presents the Vehicle Identity statement in a restrained editorial layout.",
    garment: "AS Colour 5082 Oversized Faded T-Shirt",
    weight: "240 GSM",
    material: "100% carded cotton",
    fit: "Oversized fit with dropped shoulders and wide neck ribbing.",
    details: ["Heavyweight construction", "Garment-dyed finish", "Dropped shoulders", "Wide neck ribbing", "Front MyBuildID logo", "Large back graphic"],
    availableColors: ["Faded Black", "Faded Bone", "Faded Coal"],
    availableSizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    image: null,
    imageAlt: "Identity Tee temporary product mockup",
    isAvailable: false,
    orderStatus: "Ordering opens after sample approval.",
    frontDesign: "Official MyBuildID horizontal logo.",
    backDesign: "VEHICLE IDENTITY. DOCUMENT. BUILD. INSPIRE.",
    futurePrintfulProductId: null,
    futurePrintfulVariantIds: null
  },
  {
    id: "archive-tee",
    status: "published",
    mockupUrl: null,
    alternateMockupUrls: [],
    collectionId: "identity",
    galleryKey: "archive-tee",
    name: "Archive Tee",
    collection: "Identity",
    collectionNumber: "Collection 001",
    category: "T-Shirt",
    descriptor: "Premium automotive streetwear",
    shortDescription: "An editorial tribute to every documented build.",
    description: "A premium oversized tee built around the MyBuildID archive philosophy. The understated front logo is paired with an industrial back treatment celebrating the story behind every build.",
    garment: "AS Colour 5082 Oversized Faded T-Shirt",
    weight: "240 GSM",
    material: "100% carded cotton",
    fit: "Oversized fit with dropped shoulders and wide neck ribbing.",
    details: ["Heavyweight construction", "Garment-dyed finish", "Dropped shoulders", "Wide neck ribbing", "Front MyBuildID logo", "Archive-inspired back graphic"],
    availableColors: ["Faded Black", "Faded Bone", "Faded Coal"],
    availableSizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    image: null,
    imageAlt: "Archive Tee temporary product mockup",
    isAvailable: false,
    orderStatus: "Ordering opens after sample approval.",
    frontDesign: "Official MyBuildID horizontal logo.",
    backDesign: "BUILD ARCHIVE. EST. 2026. EVERY BUILD HAS A STORY.",
    futurePrintfulProductId: null,
    futurePrintfulVariantIds: null
  },
  {
    id: "scan-my-build-tee",
    status: "published",
    mockupUrl: null,
    alternateMockupUrls: [],
    collectionId: "identity",
    galleryKey: "scan-my-build-tee",
    name: "Scan My Build Tee",
    collection: "Identity",
    collectionNumber: "Collection 001",
    category: "T-Shirt",
    descriptor: "Personalized build profile tee",
    shortDescription: "A future personalized tee connecting directly to the owner’s build.",
    description: "The third design in Collection 001. The production version will place a personalized, functional build QR code into the back graphic. Personalization and ordering are not implemented in this milestone.",
    garment: "AS Colour 5082 Oversized Faded T-Shirt",
    weight: "240 GSM",
    material: "100% carded cotton",
    fit: "Oversized fit with dropped shoulders and wide neck ribbing.",
    details: ["Heavyweight construction", "Garment-dyed finish", "Dropped shoulders", "Wide neck ribbing", "Front MyBuildID logo", "Future personalized QR artwork", "Personalized ordering coming later"],
    availableColors: ["Faded Black", "Faded Bone", "Faded Coal"],
    availableSizes: ["S", "M", "L", "XL", "2XL", "3XL"],
    image: null,
    imageAlt: "Scan My Build Tee temporary product mockup",
    isAvailable: false,
    orderStatus: "Personalized ordering coming soon.",
    frontDesign: "Official MyBuildID horizontal logo.",
    backDesign: "Personalized QR artwork with SCAN MY BUILD.",
    futurePrintfulProductId: null,
    futurePrintfulVariantIds: null
  }
];
